// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Field from "../layout-and-structure/Field.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as Stack from "../layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as LegacyIcon from "../images-and-icons/LegacyIcon.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  itemText: {
    "font-kVVagm": "font-x1qgc9lc",
    "whiteSpace-khDVqt": "whiteSpace-x1sdyfia",
    "marginLeft-koQZXg": "marginLeft-xet2fuk",
    "marginTop-keoZOQ": "marginTop-x1y332i5",
    $$css: "wino-gc:src/resources/selection-and-input/InputRadioGroupField.res.js:42"
  },
  itemTextDisabled: {
    "color-kMwMTN": "color-x1qqs05d",
    $$css: "wino-gc:src/resources/selection-and-input/InputRadioGroupField.res.js:48"
  }
};
function itemIconStyleFromParams(active, hovered) {
  return {
    0: {
      className: "backgroundColor-x17suf5r borderRadius-x1f96onm borderStyle-x1y0btm7 borderWidth-xmkeg23 boxShadow-xfgm5n5 alignItems-x6s0dn4 display-x78zum5 height-xlup9mm justifyContent-xl56j7k width-x1kky2od borderColor-x1fs2082",
      "data-style-src": "wino-gc:src/resources/selection-and-input/InputRadioGroupField.res.js:23; wino-gc:src/resources/selection-and-input/InputRadioGroupField.res.js:39"
    },
    1: {
      className: "backgroundColor-x17suf5r borderRadius-x1f96onm borderStyle-x1y0btm7 borderWidth-xmkeg23 boxShadow-xfgm5n5 alignItems-x6s0dn4 display-x78zum5 height-xlup9mm justifyContent-xl56j7k width-x1kky2od borderColor-xxyje6",
      "data-style-src": "wino-gc:src/resources/selection-and-input/InputRadioGroupField.res.js:23; wino-gc:src/resources/selection-and-input/InputRadioGroupField.res.js:36"
    }
  }[!!(active || hovered) << 0];
}
function itemTextStyleFromParams(disabled, active) {
  let tmp;
  let exit = 0;
  if (disabled && !active) {
    tmp = styles.itemTextDisabled;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = {};
  }
  return Stylex.props(styles.itemText, tmp);
}
let make = React.memo(props => {
  let disabled = props.disabled;
  let onPress = props.onPress;
  let active = props.active;
  let match = Hover.use(undefined, undefined, undefined);
  let newrecord = {
    ...{
      className: "display-x78zum5 flexDirection-x1q0g3np paddingBlock-xt970qd",
      "data-style-src": "wino-gc:src/resources/selection-and-input/InputRadioGroupField.res.js:18"
    }
  };
  newrecord.ref = Primitive_option.some(match[0]);
  let newrecord$1 = {
    ...itemIconStyleFromParams(active, !disabled && match[1])
  };
  let newrecord$2 = {
    ...itemTextStyleFromParams(disabled, active)
  };
  newrecord.children = [JsxRuntime.jsx("div", (newrecord$1.children = JsxRuntime.jsx(LegacyIcon.make, {
    name: "inner_oval",
    fill: active ? "#8a0262" : "#fefefe",
    size: 16
  }), newrecord$1)), JsxRuntime.jsx("span", (newrecord$2.children = props.children, newrecord$2))];
  return JsxRuntime.jsx(Touchable.make, {
    children: JsxRuntime.jsxs("div", newrecord),
    disabled: disabled,
    onPress: param => onPress()
  });
});
function InputRadioGroupField(props) {
  let optionToDisable = props.optionToDisable;
  let optionToText = props.optionToText;
  let __isEqualValue = props.isEqualValue;
  let onChange = props.onChange;
  let value = props.value;
  let isEqualValue = __isEqualValue !== undefined ? __isEqualValue : (a, b) => a === b;
  let newrecord = {
    ...{
      className: "marginTop-x1gslohp paddingRight-x1s7jvk7",
      "data-style-src": "wino-gc:src/resources/selection-and-input/InputRadioGroupField.res.js:14"
    }
  };
  return JsxRuntime.jsx(Field.make, {
    children: JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(Stack.make, {
      children: props.options.map(item => JsxRuntime.jsx(make, {
        children: optionToText(item),
        active: isEqualValue(value, item),
        onPress: () => onChange(item),
        disabled: optionToDisable !== undefined ? optionToDisable(item) : false
      })),
      space: "normal"
    }), newrecord)),
    label: props.label,
    errorMessage: props.errorMessage,
    required: props.required
  });
}
let make$1 = InputRadioGroupField;
export { make$1 as make };
/* styles Not a pure module */